<template>
  <div class="project">
    <div class="tiper">
      <div>变电智能在线监测 部分现场图</div>
    </div>
    <el-row :gutter="20">
      <el-col
        v-for="(x, i) in list"
        :key="i"
        :xs="24"
        :sm="12"
        :md="8"
        :lg="6"
        :xl="6"
      >
        <ImageCardCover class="ImageCardCover" v-bind="x"></ImageCardCover>
      </el-col>
    </el-row>
    <div class="tiper">
      <div>变压器光纤测温 部分现场图</div>
    </div>
    <el-row :gutter="20">
      <el-col
        v-for="(x, i) in list2"
        :key="i"
        :xs="24"
        :sm="12"
        :md="8"
        :lg="6"
        :xl="6"
      >
        <ImageCardCover class="ImageCardCover" v-bind="x"></ImageCardCover>
      </el-col>
    </el-row>
    <div class="tiper">
      <div>温控器 部分现场图</div>
    </div>
    <el-row :gutter="20">
      <el-col
        v-for="(x, i) in list3"
        :key="i"
        :xs="24"
        :sm="12"
        :md="8"
        :lg="6"
        :xl="6"
      >
        <ImageCardCover class="ImageCardCover" v-bind="x"></ImageCardCover>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped>
.tiper {
  width: 100%;
  overflow: hidden;
}
.tiper > div {
  background-color: sandybrown;
  float: left;
  color: #ffffff;
  background-color: #409eff;
  padding: 16px 32px;
}
.project {
  width: calc(100% - 32px);
  max-width: 1366px;
  margin: 0 auto;
  background-color: #ffffff;
  overflow: hidden;
  margin-top: 32px;
  margin-bottom: 132px;
}

.ImageCardCover {
  margin: 16px auto;
}
</style>

<script>
import ImageCardCover from "@/components/ImageCardCover.vue";
import { projects_zn, projects_gq, projects_wk } from "@/assets/productions.js";
export default {
  components: {
    ImageCardCover
  },
  data() {
    return {
      list: projects_zn,
      list2: projects_gq,
      list3: projects_wk
    };
  }
};
</script>
